<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">活动编号</span>
        <el-input v-model.trim="subMerId" placeholder="请输入活动编号" style="width: 150px;"/>
      </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">活动名称</span>
        <el-input v-model.trim="subMerName" placeholder="请输入活动名称" style="width: 150px;"/>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="date"
	        style="width: 300px;"
	        type="daterange"
	        value-format="yyyy-MM-dd HH:mm:ss"
	        range-separator="至"
	        start-placeholder="开始日期"
	        end-placeholder="结束日期"/>
	  </div>
	  
      <div class="dlblock-mb20 mr10">
		  
        <el-button type="primary" @click="pages.page = 1; getSnhMerchantPageFn()">
          搜索
        </el-button>
		
		<el-button type="primary" @click="editBtn(1)">
		  新增
		</el-button>
		
      </div>
	   
    </el-row>

	<br>
	
    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
	  <el-table-column align="center" prop="activityName" label="活动名称"></el-table-column>
      <el-table-column align="center" prop="threshold" label="满减阀值"></el-table-column>
	  <el-table-column align="center" prop="preferentialSubsidy" label="优惠补贴"></el-table-column>
	  <el-table-column align="center" prop="manDays" label="每人每日次数"></el-table-column>
	  <el-table-column align="center" prop="activityAmountLimit" label="活动金额上限"></el-table-column>
	  <el-table-column align="center" prop="activityStartTime" label="活动开始时间"></el-table-column>
	  <el-table-column align="center" prop="activityEndTime" label="活动结束时间"></el-table-column>
	  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	 
      <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
		  <a class="glob-a"  @click="editBtn(17, row)">更多</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	<!-- 更多 -->
	<el-dialog title="更多" :visible.sync="dialogMore.modal" width="600px">
	  
	   <!-- {{dialogMore.moreRow}} -->
	    
		          <a class="glob-a"  @click="editBtn(2, dialogMore.moreRow)">修改</a> 
				  <a class="glob-a"  @click="editBtn(3, dialogMore.moreRow)">活动分配商家</a>

	</el-dialog>
	
	<!-- 活动分配商家 查看 -->
	<el-dialog title="活动分配商家" :visible.sync="eventDistributionMerchant.modal" width="700px">
	  <el-form label-width="160px">
  <!-- <p style="text-align: center; margin: 10px 0 10px">使用 scoped-slot 自定义数据项</p> -->
  <div style="text-align: center">
    <el-transfer
      style="text-align: left; display: inline-block"
      v-model="value4"
      filterable
      :left-default-checked="[2, 3]"
      :right-default-checked="[1]"
      :titles="['未选择商户', '已选择商户']"
      :button-texts="['到左边', '到右边']"
      :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
      @change="handleChange"
      :data="data">
	  <!-- {{ option.key }} - -->
      <span slot-scope="{ option }"> {{ option.label }}</span>
    <!--  <el-button class="transfer-footer" slot="left-footer" size="small">操作</el-button>
      <el-button class="transfer-footer" slot="right-footer" size="small">操作</el-button> -->
    </el-transfer>
  </div>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="eventDistributionMerchant.modal = false">取 消</el-button>
	    <el-button type="primary" @click="eventDistributionMerchantClick">确 定</el-button>
	  </div>
	</el-dialog>
	


  <!-- 新增编辑活动 -->
    <el-dialog :title="editData.add === 1 ? '新增活动' : '编辑活动'" :visible.sync="editData.modal" width="800px">
      <el-form label-width="220px">
        <el-form-item label="名称：">
          <el-input v-model.trim="editData.activityName" placeholder="请输入活动名称"/>
        </el-form-item>
        <el-form-item label="类型：">
			<el-select v-model="editData.type" class="w150" >
			  <el-option v-for=" item in subMerTypeList " 
			  :key="item.value" :label="item.name" :value="item.value"/>
			</el-select>
        </el-form-item>
  <!-- <el-form-item label="排序方式：">
		  <el-input v-model.trim="editData.subMerSort" placeholder="请输入排序方式"/>
		</el-form-item> -->
  <!-- <el-form-item label="法定代表人或负责人证件类型：">
			<el-select v-model="editData.certificateType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in certificateTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item> -->
		<el-form-item label="活动总金额：">
		  <el-input v-model.trim="editData.activityAmountLimit" placeholder="请输入活动总金额"/>
		</el-form-item>
		<el-form-item label="每日活动上线金额：">
		  <el-input v-model.trim="editData.dailyActivityOnlineAmount" placeholder="请输入每日活动上线金额"/>
		</el-form-item>
		<el-form-item label="每日每人活动上线金额：">
		  <el-input v-model.trim="editData.dailyOnlineAmountPerPerson" placeholder="请输入每日每人活动上线金额"/>
		</el-form-item>
		<el-form-item label="每人活动限制次数：">
		  <el-input v-model.trim="editData.perPersonActivityLimitFrequency" placeholder="请输入每人活动限制次数"/>
		</el-form-item>
	<!--  <el-form-item label="企业证件类型：">
			<el-select v-model="editData.companyCertType" class="w150" placeholder="企业商户必选" clearable>
			  <el-option v-for="(item, index) in companyCertTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item> -->
		<el-form-item label="每人每日活动限制次数：">
		  <el-input v-model.trim="editData.manDays" placeholder="请输入每人每日活动限制次数"/>
		</el-form-item>
		<el-form-item label="支付渠道：">
			<el-checkbox-group v-model="editData.paymentChannelsArray" @change="handleCheckedCitiesChange" >
			    <el-checkbox label="农行掌银" ></el-checkbox>
				<el-checkbox label="农行快E支付" ></el-checkbox>
			    <el-checkbox label="微信"   ></el-checkbox>
			    <el-checkbox label="支付宝" ></el-checkbox>
			  </el-checkbox-group>
		</el-form-item>
		
		<el-form-item label="是否首次一元购买所有：" >
			  <el-radio-group v-model="editData.firstDollar">
			      <el-radio :label="0">是</el-radio>
			      <el-radio :label="1">否</el-radio>
			  </el-radio-group>
		</el-form-item>
		
		<el-form-item label="是否当天一元购买所有：" >
			  <el-radio-group v-model="editData.dayFirstDollar">
			      <el-radio :label="0">是</el-radio>
			      <el-radio :label="1">否</el-radio>
			  </el-radio-group>
		</el-form-item>
		
		<el-form-item label="是否本周一元购买所有：" >
			  <el-radio-group v-model="editData.weekFirstDollar">
			      <el-radio :label="0">是</el-radio>
			      <el-radio :label="1">否</el-radio>
			  </el-radio-group>
			  &nbsp;&nbsp;<el-input v-if="editData.weekFirstDollar == 0" v-model.trim="editData.weekFirstDollarCount" placeholder="次数上限" style="width: 20%;"/>
		</el-form-item>
		
		<el-form-item label="是否当月一元购买所有：" >
			  <el-radio-group v-model="editData.monthFirstDollar">
			      <el-radio :label="0">是</el-radio>
			      <el-radio :label="1">否</el-radio>
			  </el-radio-group>
			  &nbsp;&nbsp;<el-input v-if="editData.monthFirstDollar == 0" v-model.trim="editData.monthFirstDollarCount" placeholder="次数上限" style="width: 20%;"/>
		</el-form-item>
		
		<el-form-item label="是否活动时间内一元购买所有：" >
			  <el-radio-group v-model="editData.duringActivityTimeFirstDollar">
			      <el-radio :label="0">是</el-radio>
			      <el-radio :label="1">否</el-radio>
			  </el-radio-group>
		</el-form-item>
		
		<el-form-item label="是否开启白名单：" >
			  <el-radio-group v-model="editData.whiteListFirstDollar">
			      <el-radio :label="0">是</el-radio>
			      <el-radio :label="1">否</el-radio>
			  </el-radio-group>
		</el-form-item>
		
		<!-- 周 -->
		<el-form-item label="周：">  
			<el-checkbox-group v-model="editData.weekCheckedDayArray" @change="weekHandleCheckedCitiesChange">
			   <el-checkbox label="1" >星期一</el-checkbox>
			   <el-checkbox label="2" >星期二</el-checkbox>
			   <el-checkbox label="3" >星期三</el-checkbox>
			   <el-checkbox label="4" >星期四</el-checkbox>
			   <el-checkbox label="5" >星期五</el-checkbox>
			   <el-checkbox label="6" >星期六</el-checkbox>
			   <el-checkbox label="0" >星期天</el-checkbox>
			</el-checkbox-group>
			<div style="color:rgb(247, 135, 135);">未选择不限制</div>
		</el-form-item>
		  
		<el-form-item label="一元购买所有：">
			 <el-input v-model.trim="editData.oneYuan" placeholder="一元购买所有(默认一元,开启生效)"/>
		</el-form-item>
		
		<el-form-item label="使用条件：" v-if="editData.type == 1">
		 满 <el-input v-model.trim="editData.threshold" placeholder="请输入满减阀值" style="width: 40%;" /> 减
		  <el-input v-model.trim="editData.preferentialSubsidy" placeholder="优惠补贴" style="width: 40%;" /> 
		</el-form-item>
		
		<el-form-item label="使用条件：" v-if="editData.type == 2">
		 消费满 <el-input v-model.trim="editData.threshold" placeholder="金额" style="width: 30%;" /> 随机立减
		  <el-input v-model.trim="editData.preferentialSubsidy" placeholder="起" style="width: 20%;" /> 到
		  <el-input v-model.trim="editData.preferentialSubsidyEnd" placeholder="止" style="width: 20%;" />
		</el-form-item>
		
		<el-form-item label="使用条件：" v-if="editData.type == 3">
		 消费满 <el-input v-model.trim="editData.threshold" placeholder="金额" style="width: 12%;" /> 第几次
		  <el-input v-model.trim="editData.preferentialSubsidy" placeholder="起" style="width: 12%;" /> 到第几次打折
		  <el-input v-model.trim="editData.preferentialSubsidyEnd" placeholder="止" style="width: 12%;" />折扣
		  <el-input v-model.trim="editData.discount" placeholder="折扣" style="width: 12%;" />
		</el-form-item>
		
		<!-- type datetime -->
		<el-form-item label="活动时间：">
			<el-date-picker
			    v-model="editData.activityTime"
			    style="width: 300px;"
				class="reset-clear"
			    type="daterange"  
				:clearable="false"
				unlink-panels
				start-placeholder="开始日期"
			    range-separator="至"
			    end-placeholder="结束日期"
				value-format="yyyy-MM-dd HH:mm:ss"
				:default-time="['00:00:00', '23:59:59']"
				/>
		</el-form-item>
	<!--	<el-form-item label="地址：">
		  <el-input v-model.trim="editData.address" placeholder="非必须"/>
		</el-form-item> -->
		<el-form-item label="状态：">
			<el-select v-model="editData.state" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in accountTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="备注：">
		  <el-input type="textarea" v-model.trim="editData.remarks" placeholder="非必须"/>
		</el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </div>
    </el-dialog>
	
	<!-- 图片放大 -->
	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	</el-dialog>
	
  </div>
</template>

<script>
  import {
	//满减活动
	getSnhFullReduction,
	//活动更新或新增
	snhFullReductionSaveOrUpdate,
	//商户与活动关系 建立 查看 二级商户列表
	ydBusinessListings,
	//商户与活动关系 新增与更新
	ydSaveOrUpdate,

	//二级商户信息分页查看
    getSnhMerchantPage,
	//二级商户标记删除
	delSnhMerchantPage,
	//6.48	二级商户信息同步（新）
	secondaryMerchantInformationSynchronizationNew,
	//6.49	二级商户状态变更请求
	secondaryMerchantStatusChangeRequest,
	//6.5	二级商户签约确认
	signingConfirmationOfSecondaryMerchants,
	//6.45	二级商户信息查询
	secondaryMerchantInformationQuery,
	//6.35	二级商户余额查询
	secondaryMerchantBalanceQuery,
	//6.53	二级商户签约短信验证码重发
	sendMobileMessageForSubMerRequest,
	//6.26	身份验证（非页面跳转）
	authenticationNonPageJump,
	//6.24	身份验证（页面跳转）
	authenticationPageJump,
	//6、授权支付签约（银行端）
	authorizedPaymentSigningBankEnd,
	//6.16	授权支付签约（商户端）—申请
	authorizedPaymentSigningMerchantSideApplication,
	//6.17	授权支付签约（商户端）—确认
	authorizedPaymentSigningMerchantSideConfirmation,
	//6.18	授权支付签约（商户端）—验证码重发
	authorizedPaymentSigningMerchantSideVerificationCodeResend,
	//6.32	二级商户信息同步（不再支持）
	ydSnhRegSubMerchantInfoRequestOld,
	//6.44	掌银被扫支付请求
	ydSnhPalmBankIsSweptToPay,
	//6.20	授权支付签约/解约结果查询
	ydAuthorizedPaymentSigningCancelingResultQuery,
	//6.19	授权支付解约
	ydTerminationOfAuthorizedPayment,
	//6.11	对账单查询
	ydStatementQuery,
	//6.40	平台商户对账单下载
	ydPlatformMerchantStatementDownload,
	//6.27	预授权确认/取消
	ydPreAuthorizationConfirmationCancellation,
	//6.38	电子回单下载
	ydElectronicReceiptDownload,
	//6.40	鉴权交易结果查询（不再支持）
	ydAuthenticationQuery,
	//6.42	出金交易查询
	ydDepositTransactionInquiry,
	//6.46	二级商户迁移
	ydSecondaryBusinessMigration,
	//1、第三方POS对账单下载
	ydPOSThirdFileDownloadRequest,
	//2、查询POS（二级）商户T日清算金额
	ydQuerySubMerTdaySettleRequest,
	//3、第三方POS订单登记
	ydRegisterPOSOrderRequest,
	//4、第三方交易渠道订单确认
	ydThirdConfirmSendMQOrderRequest,
	//5、第三方交易渠道订单同步
	ydBatchRegisterRequest,
	//6.10	交易明细查询
	ydTransactionDetailEnquiry,
	
	//6.6	单笔退款
	ydSingleRefund,
	//6.9	单笔交易查询
	ydSingleTransactionQuery
	
  } from '@/api'

   import WordImg from '@/components/WordImg.vue'

  export default {
    name: 'WordList',
    components: {WordImg},
    data () {
      return {
		//二级商户编号
		subMerId:'',
		//二级商户名称
		subMerName:'',
        date: '',
        tableData: [],
        tableLoading: false,
		//更多
		dialogMore:{
		modal:false,
		//更多选中操作列表中的一条
		moreRow:{}
		},
		//6.35	二级商户余额查询 查看
		dialogMerchantBalance:{
		  modal:false,
		  data:{
			  merchant:{merchantID:''},
			  trxResponse:{merchantName:''}
		  }
		},
		//6.45	二级商户信息查询
        auditShow: {
          modal: false,
          data: {
			  merchantName:'',
			  subAccountRecords:{}
		  }
        },
		//6.53	二级商户签约短信验证码重发
		signUpSMS:{
			modal: false,
			data: {}
		},	
		//二级商户类型
		subMerTypeList:[{name:"满减",value:"1"},{name:"随机立减",value:"2"},{name:"打折",value:"3"}],
		//法定代表人或负责人证件类型
		certificateTypeList:[{name:"请选择",value:""},{name:"身份证",value:"I"},{name:"护照",value:"P"},{name:"军官证",value:"G"},{name:"其它证件",value:"U"}],	
		//企业证件类型
		companyCertTypeList:[{name:"请选择",value:""},{name:"营业执照",value:"U"},{name:"组织机构代码证",value:"Y"},{name:"统一社会信用代码",value:"V"}],
		//收款账户类型
		accountTypeList:[{name:"启用",value:"0"},{name:"关闭",value:"1"}],
		//活动
        editData:{
          modal: false,
		  //支付渠道
		  paymentChannels: [],
		  //支付渠道 数组
		  paymentChannelsArray:[],
		  //使用条件 满 多少 减 多少
		  threshold:'',
		  //优惠补贴
		  preferentialSubsidy:'',
		  //活动时间
		  activityTime:[],
		  
          userId: '',
          add: 1,
		  //二级商户名称
          subMerName: '',
		  //类型
		  subMerType:'1',
		  //排序方式
		  subMerSort:'',
		  //法定代表人或负责人证件类型
		  certificateType:'',
		  //法定代表人或负责人证件编号
		  certificateNo:'',
		  //法定代表人或负责人名称
		  contactName:'',
		  //企业名称
		  companyName:'',
		  //企业证件类型
		  companyCertType:'',
		  //企业证件编号
		  companyCertNo:'',
		  //收款户名
		  accountName:'',
		  //收款账号
		  account:'',
		  //收款银行
		  bankName:'',
		  //银行预留手机号
		  mobilePhone:'',
		  //地址
		  address:'',
		  //收款账户类型
		  accountType:'',
		  //商户负责人联系电话
		  merMobilePhone:'',
		  //备注
		  remark:'',
		  //是否首次一元购买所有 0是 1否
		  firstDollar:'',
		  //折扣
		  discount:'',
		  //是否开启白名单
		  whiteListFirstDollar:'',
		  //周
		  weekCheckedDayArray: []		  
		  },
		// 商户状态变更
		statusData: {
		  modal: false,
		  userId: '',
		  type: '',
		  typeName: '',
		  date: [],
		  content: ''
		},
		//商户签约设置
		signAcontractData:{
			modal: false,
			subMerId: '',
			verificationCode:'',
			randomAmount:'',
			account:''
		},
		//14 交易明细查询
		transactionDetailsData:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.11 交易对账单下载
		transactionAccountStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.40	平台商户对账单下载
		platformMerchantStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		
		//活动分配商家
		eventDistributionMerchant:{
			 modal: false,
			 activityNumber:''
		},
		data: [],
		value4:[],
		value:[],
		
		//为选中商户数组
		merchantArray:[],
		//Transfer 穿梭框 选中数组
		movedKeys:[],
		//穿梭框 左右
		direction:'',
  
		 }
    },
    created () {
      this.getSnhMerchantPageFn()
    },
    methods: {
		//6.48	二级商户信息同步（新）
		secondaryMerchantInformationSynchronizationNewFn () {
		  this.tableLoading = true
		  secondaryMerchantInformationSynchronizationNew({
			  id:this.editData.id
		  }).then(res => {
			  this.$message.success(res.data)
			  this.getSnhMerchantPageFn();
		  }).finally(() => {
		    this.tableLoading = false
		  })
		},
      getSnhMerchantPageFn() {
        this.tableLoading = true
        getSnhFullReduction({
          pageNum: this.pages.page,
          createTime: this.date && this.date.length ? this.date[0] : '',
          updateTime: this.date && this.date.length > 1 ? this.date[1] : '',
          id: this.subMerId,
          activityName: this.subMerName
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  //6.35	二级商户余额查询
	  secondaryMerchantBalanceQueryFn(subMerId){
		 console.info("二级商户余额查询",subMerId);
		 this.tableLoading = true
		 secondaryMerchantBalanceQuery({subMerId:subMerId}).then(res => {
			 //弹出二级商户余额 显示dialog
			 //更多
			 this.dialogMerchantBalance = {
			 	  modal:true,
			 	  data:res.data	  
			 }
			 console.info("6.35	二级商户余额查询 ",this.dialogMerchantBalance);	 
		  this.$message.success(res.msg)
		  this.tableLoading = false
		 }).finally(() => {
		   this.tableLoading = false
		 })  
	  },
	  //商户签约
	  signAcontract(){
		  console.info("二级商户签约",this.signAcontractData.subMerId);
		  this.tableLoading = true
		  signingConfirmationOfSecondaryMerchants({
			  subMerchantNo:this.signAcontractData.subMerId,
		      verificationCode:this.signAcontractData.verificationCode,
			  randomAmount:this.signAcontractData.randomAmount,
			  account:this.signAcontractData.account,
		  }).then(res => {
			//签约
		   this.signAcontractData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //6.10	交易明细查询
	  transactionDetails(){
		  this.tableLoading = true
		  ydTransactionDetailEnquiry({
					  //查询日期	必须设定，YYYY/MM/DD
		  			  settleDate:this.transactionDetailsData.settleDate,
					  //查询结束日期 必须设定，YYYY/MM/DD
					  settleDateEnd:this.transactionDetailsData.settleDateEnd,
					  //压缩标识	必须设定，1：压缩，0：不压缩
		  			  zip:this.transactionDetailsData.zip
		  }).then(res => {
		   this.transactionDetailsData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //6.11 交易对账单下载
	  transactionAccountStatement(){
		  this.tableLoading = true
		  			ydStatementQuery({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.transactionAccountStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.transactionAccountStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.transactionAccountStatementDialog.zip
		  			}).then(res => {
						this.transactionAccountStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.40	平台商户对账单下载
	  platformMerchantStatement(){
		  //6.40	平台商户对账单下载
		  			this.tableLoading = true
		  			ydPlatformMerchantStatementDownload({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.platformMerchantStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.platformMerchantStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.platformMerchantStatementDialog.zip
		  			}).then(res => {
						this.platformMerchantStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.45	二级商户信息查询
	  secondaryMerchantInformationQueryFn(){
		  console.info("二级商户信息查询",this.auditShow.subMerId);
		  this.tableLoading = true
		  secondaryMerchantInformationQuery({
		  			  subMerId:this.auditShow.subMerId
		  }).then(res => {
		   this.auditShow.data = res.data;
		   if(res.data.accountRecords.length > 0){
		   this.auditShow.data.subAccountRecords = res.data.accountRecords[0]
		   }
		   //console.info(this.auditShow.data.subAccountRecords,"=======") //JSON.parse()
		   //this.$message.success(res)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //二级商户标记删除
	  delSnhMerchantPageFn(id) {
		  console.info("二级商户标记删除",id);
	    this.tableLoading = true
	    delSnhMerchantPage({id:id}).then(res => {
	     this.$message.success(res.msg)
	     this.getSnhMerchantPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  //活动分配商家 Transfer 穿梭框 确认事件
	  eventDistributionMerchantClick(){
		  this.tableLoading = true
		  ydSaveOrUpdate({
			  id:this.eventDistributionMerchant.activityNumber,
			  merchantArray:this.merchantArray,
			  activeSelectionArray:this.movedKeys,
			  direction:this.direction
		  }).then(res => {
		   this.$message.success(res.msg)
		   this.getSnhMerchantPageFn()
		  }).finally(() => {
		    this.tableLoading = false
		  })
		  //关闭弹窗
		  this.eventDistributionMerchant = {modal:false}
		  
		  //未选择的商户
		  this.data
		  console.info(this.data,"未选择的商户")
		  //穿梭框选中的数组
		  this.movedKeys
		  console.info(this.movedKeys,"穿梭框选中的数组")
		  
	  },
	  //Transfer 穿梭框
	   handleChange(value, direction, movedKeys){
		      this.merchantArray = value
			  console.log(value, "1");
			  //左右方向
			  console.log(direction, "2");
			  this.direction = direction
			  
	          console.log(movedKeys, "3");
			  this.movedKeys = movedKeys
	   },
	    generateData(){
			const data = [];
			const value4 = [];
			this.tableLoading = true
			ydBusinessListings({id:this.eventDistributionMerchant.activityNumber }).then(res => {
			if(res.code === 200){
			for (let i = 0; i < res.data.merchantList.length; i++) {
			  data.push({
			    key: res.data.merchantList[i].id,
			    label:res.data.merchantList[i].remark,
			    //disabled: i % 4 === 0
			  });
			}
			
			//已选择的
			for (let j = 0; j < res.data.inMerchantList.length; j++) {
			  value4.push(res.data.inMerchantList[j].id);
			  //value4.push({
			  //  key: res.data.notMerchantList[j].id,
			  //  label:res.data.notMerchantList[j].subMerName,
			  //  disabled: i % 4 === 0
			  //});
			  
			}
			
			 this.tableLoading = false
			 }else{
				 this.$message.success(res.msg)
			 }
			}).finally(() => {
			  this.tableLoading = false
			}) 
			this.data = data
			this.value4 = value4
			console.info("===ydBusinessListings = data ====",this.data)
			console.info("===ydBusinessListings= value4 ====",this.value4)
			
	        return data;
	    },
		renderFunc(h, option) {
		  return '<span>{'+ option.key+ ' } - {'+ option.label +'}</span>';
		},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6状态变更
		  if(t == 1){
			 this.editData = {
			   modal: true,
			   add: 1,
			   //支付渠道 数组
			   paymentChannelsArray:[]
			 }
		  }else if(t == 2){
			  //活动
			  this.editData = {
			    modal: true,
				//编号
				id: row.id,
				//活动名称
				activityName:row.activityName,
				//活动总金额
				activityAmountLimit:row.activityAmountLimit,
				//活动类型
				type:row.type,
				//每日活动上线金额
				dailyActivityOnlineAmount:row.dailyActivityOnlineAmount,
				//每日每人活动上线金额
				dailyOnlineAmountPerPerson:row.dailyOnlineAmountPerPerson,
				//每人活动限制次数
				perPersonActivityLimitFrequency:row.perPersonActivityLimitFrequency,
				//每人每日活动限制次数
				manDays:row.manDays,
				//支付渠道
				paymentChannels:row.paymentChannels,
				//支付渠道 数组
				paymentChannelsArray:row.paymentChannelsArray,
				//使用条件 满 多少 减 多少
				threshold:row.threshold,
				//优惠补贴
				preferentialSubsidy:row.preferentialSubsidy,
				//优惠补贴end
				preferentialSubsidyEnd:row.preferentialSubsidyEnd,
				//活动 开始时间 结束时间
				activityTime:[row.activityStartTime,row.activityEndTime],
				//状态
				state:row.state,
				//备注
				remarks:row.remarks,
				//是否首次一元购买所有 0是 1否
				firstDollar:row.firstDollar,
				//是否当天一元购买所有
				dayFirstDollar:row.dayFirstDollar,
				//是否本周一元购买所有
				weekFirstDollar:row.weekFirstDollar,
				//是否本周一元购买所有 次数上限 0没有限制
				weekFirstDollarCount:row.weekFirstDollarCount,
				//是否当月一元购买所有
				monthFirstDollar:row.monthFirstDollar,
				//是否当月一元购买所有 次数上限 0没有限制
				monthFirstDollarCount:row.monthFirstDollarCount,
				//是否活动时间内一元购买所有
				duringActivityTimeFirstDollar:row.duringActivityTimeFirstDollar,
				//一元购买所有
				oneYuan:row.oneYuan,
				//折扣
				discount:row.discount,
				//是否开启白名单
				whiteListFirstDollar:row.whiteListFirstDollar,
				//周
				weekCheckedDayArray:row.weekCheckedDayArray,
				//1新增 2编辑
				add: 2,
			  }
			  
			  console.info(this.editData,"活动编辑")
			  
		  }else if(t == 3) {
		 
		  //活动分配商家
	      this.eventDistributionMerchant = {
	        modal: true,
			activityNumber:row.id
	      }
		  //活动 已选中 未选中 商户加载
		  this.generateData()
		  
	    }else if(t == 4) {
	      this.imgPreData = {
	        modal: true,
	        url: this.auditShow.data.picture
	      }
	    }else if(t == 5){
			this.$confirm(`确认要删除吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
				 let id =  row.id
			     this.delSnhMerchantPageFn(id);
			});
		}else if(t == 6){
			//商户状态变更
		this.statusData = {
		  modal: true,
		  subMerId: row.subMerId,
		  updateFlag: row.state,
		  date: [],
		  content: ''
		}
		}else if(t == 7){
			//签约
			this.signAcontractData = {
				modal: true,
				subMerId: row.subMerId,
				verificationCode:'',
				randomAmount:'',
				account:row.account
			}
		}else if(t == 8){
			//6.45	二级商户信息查询
			this.auditShow = {modal: true, subMerId: row.subMerId}
			this.secondaryMerchantInformationQueryFn()
		}else if(t == 9){
			//6.53	二级商户签约短信验证码重发
			this.signUpSMS = {
				modal: true,
				 subMerId: row.subMerId,
				 subMerchantAccNo:row.account
			}
		}else if(t == 10){
			//6.35	二级商户余额查询
			console.info("6.35	二级商户余额查询",row.subMerId)
			this.secondaryMerchantBalanceQueryFn(row.subMerId)
		}else if(t == 11){
			//6.26	身份验证（非页面跳转）
			console.info("6.26	身份验证（非页面跳转）");
			this.tableLoading = true
			authenticationNonPageJump({ 
				//客户类型
				customType:row.customType,
				//客户姓名
				clientName:row.accountName,
				//银行帐号
				accNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//手机号
				mobileNo:row.merMobilePhone,
				//网银客户号
				customNo:'',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 12){
			//6.24	身份验证（页面跳转）
			console.info("6.24	身份验证（页面跳转）");
			this.tableLoading = true
			authenticationPageJump({ 
				//客户类型
				customType:row.customType,
				//银行帐号
				bankCardNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 13){
			//6、授权支付签约（银行端） 
			console.info("6、授权支付签约（银行端）");
			this.tableLoading = true
			authorizedPaymentSigningBankEnd({ 
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//卡类型
				cardType:'A',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 14){
			//6.16	授权支付签约（商户端）—申请
			console.info("6.16	授权支付签约（商户端）—申请");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideApplication({ 
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//签约卡号
				cardNo:row.account,
				//卡类型
				cardType:'A',
				//手机号
				mobileNo:row.mobilePhone,
				//证件类型
				certificateType:row.certificateType,
				//证件号码
				certificateNo:row.certificateNo,
				//客户姓名
				accName:row.accountName
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 15){
			//6.17	授权支付签约（商户端）—确认
			console.info("6.17	授权支付签约（商户端）—确认");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideConfirmation({ 
				//交易编号	
				orderNo:'3GECEP01223743931840',
				//验证码	
				verifyCode:row.account
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 16){
			//6.18	授权支付签约（商户端）—验证码重发
			console.info("6.18	授权支付签约（商户端）—验证码重发");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideVerificationCodeResend({ 
				//交易编号	
				orderNo:'1',
				//签约卡号	
				cardNo:row.account
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 17 ){
			console.info("更多",row)
			//更多
			this.dialogMore = {
				  modal:true,
				  moreRow:row	  
			}
		}else if( t == 18 ){
			//同步old
			this.tableLoading = true
			ydSnhRegSubMerchantInfoRequestOld({ 
				//编号
				id: row.id
			}).then(res => {
			 this.$message.success(res.data)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 19 ){
			//6.44	掌银被扫支付请求
			this.tableLoading = true
			ydSnhPalmBankIsSweptToPay({ 
				//编号
				id: row.id,
				//二级商户编号
				subMerId:row.subMerId,
				//支付二维码信息
				payCode:6235613048944148431
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 20 ){
			//6.48	二级商户信息同步（新）
			this.editData.id = row.id
			this.secondaryMerchantInformationSynchronizationNewFn()
		}else if( t == 21 ){
			//6.20	授权支付签约/解约结果查询
			this.tableLoading = true
			ydAuthorizedPaymentSigningCancelingResultQuery({
				//签约编号
				orderNo:row.id
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 22 ){
			//6.19	授权支付解约
			this.tableLoading = true
			ydTerminationOfAuthorizedPayment({
				//交易编号
				orderNo:row.id,
				//签约编号
				agentSignNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 23 ){
			// 14、交易明细查询 弹出选择框
			this.transactionDetailsData = { modal: true }
		}else if( t == 24 ){
			//6.11	对账单查询
			this.transactionAccountStatementDialog = { modal: true }
		}else if( t == 25 ){
			//6.40	平台商户对账单下载
			this.platformMerchantStatementDialog = { modal: true }
		}else if( t == 26 ){
			//6.27	预授权确认/取消
			this.tableLoading = true
			ydPreAuthorizationConfirmationCancellation({
				//交易类型
				operateType:'',
				//交易日期
				orderDate:'',
				//交易时间
				orderTime:'',
				//交易编号
				orderNo:'',
				//原交易编号
				originalOrderNo:'',
				//币种
				currencyCode:'',
				//金额
				orderAmount:'',
				//手续费金额
				fee:'',
				//附言
				merchantRemarks:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 27 ){
			//6.38	电子回单下载
			this.tableLoading = true
			ydElectronicReceiptDownload({
				//二级商户编号
				subMerchantNo:'',
				//支付订单编号
				orderNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 28 ){
			//6.40	鉴权交易结果查询（不再支持）
			this.tableLoading = true
			ydAuthenticationQuery({
				//鉴权交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 29 ){
			//6.42	出金交易查询
			this.tableLoading = true
			ydDepositTransactionInquiry({
				//外转（出金）交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 30 ){
			//二级商户迁移
			this.tableLoading = true
			ydSecondaryBusinessMigration({
				//源平台商户号 必须设定
				fromMerchantNo:'',
				//待迁移二级商户编号   必须设定
				subMerchantNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 31 ){
			//第三方POS对账单下载
			this.tableLoading = true
			ydPOSThirdFileDownloadRequest({
				//二级商户号
				subMerchantID:'',
				//对账单下载日期
				fileDate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 32){
			//查询POS（二级）商户T日清算金额 
			this.tableLoading = true
			ydQuerySubMerTdaySettleRequest({
				//二级商户号
				subMerchantNo:'',
				//清算日期
				trxDate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 33 ){
			//3、第三方POS订单登记
			this.tableLoading = true
			ydRegisterPOSOrderRequest({
				//二级商户号
				subMerchantNo:'',
				//订单号
				orderNo:'',
				//订单日期
				orderDate:'',
				//序列号
				sequenceNo:'',
				//订单金额
				amount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 34 ){
			//4、第三方交易渠道订单确认 
			this.tableLoading = true
			ydThirdConfirmSendMQOrderRequest({
				//订单号
				orderNo:'',
				//确认订单号
				newOrderNo:'',
				//确认金额
				orderAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 35 ){
			//5、第三方交易渠道订单同步
			this.tableLoading = true
			ydBatchRegisterRequest({
				//批次号
				batchNo:'',
				//批次日期
				batchDate:'',
				//批次日期
				batchTime:'',
				//本批次笔数
				batchCount:'',
				//本批次金额
				batchAmount:'',
				//交易总笔数
				totalCount:'',
				//交易总金额
				totalAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 36 ){
			//6.6	单笔退款
			this.tableLoading = true
			ydSingleRefund({
				//商户退款账号 非必须
				merRefundAccountNo:'',
				//商户退款名		非必须
				merRefundAccountName:'',
				//支付订单号		必须设定
				orderNo:'',
				//退款交易编号	必须设定
				newOrderNo:'',
				//退款金额		必须设定
				trxAmount:'',
				//维权退款标志        非必须，0:普通退款，1:维权退款
				refundType:'',
				//附言			非必须
				merchantRemarks:'',
				//平台商户担保支付退款资金来源    非必须 ，1：担保账簿 2:二级商户账簿 3：退款账簿
				merRefundAccountFlag:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 37 ){
			//6.9	单笔交易查询
			this.tableLoading = true
			ydSingleTransactionQuery({
				// 交易类型		必须设定,ImmediatePay：直接支付
				// PreAuthPay：预授权支付
				// DividedPay：分期支付
				// AgentPay：授权支付
				// Refund：退款
				// DefrayPay：付款
				// PreAuthed：预授权确认
				// PreAuthCancel：预授权取消
				payTypeID:'',
				//交易编号		必须设定
				orderNo:'',
				//是否查询详细信息	必须设定, 0：状态查询； 1：详细查询
				queryDetail:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}
	},
	//活动 新增或更新
	snhFullReductionSaveOrUpdateFn(){
	this.tableLoading = true
	snhFullReductionSaveOrUpdate({ 
		//编号
		id:this.editData.id,
		//活动名称
		activityName:this.editData.activityName,
		//活动总金额
		activityAmountLimit:this.editData.activityAmountLimit,
		//活动类型
		type:this.editData.type,
		//每日活动上线金额
		dailyActivityOnlineAmount:this.editData.dailyActivityOnlineAmount,
		//每日每人活动上线金额
		dailyOnlineAmountPerPerson:this.editData.dailyOnlineAmountPerPerson,
		//每人活动限制次数
		perPersonActivityLimitFrequency:this.editData.perPersonActivityLimitFrequency,
		//每人每日活动限制次数
		manDays:this.editData.manDays,
		//支付渠道
		paymentChannels:this.editData.paymentChannels,
		//支付渠道 数组
		paymentChannelsArray:this.editData.paymentChannelsArray,
		//使用条件 满 多少 减 多少
		threshold:this.editData.threshold,
		//优惠补贴
		preferentialSubsidy:this.editData.preferentialSubsidy,
		//优惠补贴end
		preferentialSubsidyEnd:this.editData.preferentialSubsidyEnd,
		//活动开始时间 结束时间 
		activityStartTime:this.editData.activityTime && this.editData.activityTime.length ? this.editData.activityTime[0] : '',
		//活动结束时间
		activityEndTime:this.editData.activityTime && this.editData.activityTime.length ? this.editData.activityTime[1] : '',
		//状态
		state:this.editData.state,
		//备注
		remarks:this.editData.remarks,
		//是否首次一元购买所有
		firstDollar:this.editData.firstDollar,
		//是否当天一元购买所有
		dayFirstDollar:this.editData.dayFirstDollar,
		//是否本周一元购买所有
		weekFirstDollar:this.editData.weekFirstDollar,
		//是否本周一元购买所有 次数上限 0没有限制
		weekFirstDollarCount:this.editData.weekFirstDollarCount,
		//是否当月一元购买所有
		monthFirstDollar:this.editData.monthFirstDollar,
		//是否当月一元购买所有 次数上限 0没有限制
		monthFirstDollarCount:this.editData.monthFirstDollarCount,
		//是否活动时间内一元购买所有
		duringActivityTimeFirstDollar:this.editData.duringActivityTimeFirstDollar,
		//一元购买所有
		oneYuan:this.editData.oneYuan,
		//折扣
		discount:this.editData.discount,
		//是否开启白名单
		whiteListFirstDollar:this.editData.whiteListFirstDollar,
		//周
		weekCheckedDayArray:this.editData.weekCheckedDayArray
	}).then(res => {
	 this.$message.success(res.msg)
	 this.tableLoading = false
	 this.editData.modal = false
	 //刷新
	 this.getSnhMerchantPageFn() 
	}).finally(() => {
	  this.tableLoading = false
	}) 
	},
	 //选择框
	 handleCheckedCitiesChange(value) {
	        //let checkedCount = value.length;
			//this.$message.success(checkedCount)
			
			//alert(value)
	 },

	//活动新增或更新
	addBtn (t) {
	  if (this.editData.add == 1) {
		  //添加
		  this.snhFullReductionSaveOrUpdateFn()
	  } else {
		  //修改
		this.snhFullReductionSaveOrUpdateFn()
	  }
	},
      pageChange(val){
        this.pages.page = val
        this.getSnhMerchantPageFn()
      },
	   //周
	   weekHandleCheckedCitiesChange(value){
		   console.info("handleCheckedCitiesChange",value)
	          //let checkedCount = value.length;
	          //this.isIndeterminate = checkedCount > 0 && checkedCount < this.weekCitiesUp.length;
	    }
    }
  }
</script>

<style scoped>
  .transfer-footer {
	    margin-left: 20px;
	    padding: 6px 5px;
   }
	  
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
